import {StorageWrapper} from '../../../shared/scripts/StorageWrapper.ts'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup.ts'
import {PushNotificationPopupIntentEnum, USER_ACTION_ENUM} from '../notifications/UIMRequestPushNotificationController.ts'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler.ts'
import {CA} from '../../../shared/scripts/analytics/Analytics.ts'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas.ts'

export class UIMRequestPushNotificationOnFriendRequestPopup extends ViewPopup {
    constructor() {
        super({key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.title'},
            {key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.body'},
            () => {
                UIMDeviceHandler.requestNotificationPermission()
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestPushNotificationsPopup,
                    floatValue: USER_ACTION_ENUM.USER_ACCEPTED_PUSH_NOTIFICATION,
                    stringValue: PushNotificationPopupIntentEnum.OnUserSentFriendRequest,
                })
                StorageWrapper.setPushNotificationRequestStatus(true)
            },
            () => {
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestPushNotificationsPopup,
                    floatValue: USER_ACTION_ENUM.USER_REJECTED_PUSH_NOTIFICATION,
                    stringValue: PushNotificationPopupIntentEnum.OnUserSentFriendRequest,
                })
            },
            false,
            {
                checkButtonCustomContent: {key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.notifyMe'},
                xButtonCustomContent: {key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.notNow'},
            },)

        this.stylePopup()
        this.show()
    }

    private stylePopup() {
        this.body.classList.add('request-push-notification-body')
        this.xButton.classList.add('btn_ghost')
        this.xButton.style.maxWidth = 'unset'
        this.checkButton.style.maxWidth = 'unset'
    }
}
